var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_38149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.9696H8.99999V14.9696H12.5C13.052 14.9696 13.5 14.5216 13.5 13.9696C13.5 13.4176 13.052 12.9696 12.5 12.9696H10.5V10.9696H11.833C12.385 10.9696 12.833 10.5216 12.833 9.96961C12.833 9.41761 12.385 8.96961 11.833 8.96961H8.99999V6.96961H11.833C13.487 6.96961 14.833 8.31561 14.833 9.96961C14.833 10.5736 14.653 11.1356 14.345 11.6066C15.047 12.1566 15.5 13.0106 15.5 13.9696C15.5 15.6236 14.154 16.9696 12.5 16.9696ZM24 15.2596C24 15.2596 22.756 14.5716 20.879 14.2516C21.89 14.1206 23.055 13.6846 23.552 12.4416C24.514 10.0336 23.629 6.82261 23.629 6.82261C23.629 6.82261 22.323 7.31261 20.988 8.57261C21.677 7.50961 22.362 5.95261 21.691 4.60361C20.54 2.28861 17.5 0.974609 17.5 0.974609C17.5 0.974609 16.115 4.83161 18.142 8.83761C18.957 13.7336 17.499 16.7826 16.095 18.4986C14.832 20.0426 13.274 20.9216 12 21.2336C10.726 20.9206 9.16899 20.0416 7.90499 18.4986C6.50099 16.7816 5.04299 13.7336 5.85799 8.83761C7.88499 4.83161 6.49999 0.974609 6.49999 0.974609C6.49999 0.974609 3.45999 2.28861 2.30899 4.60461C1.63799 5.95461 2.32399 7.51061 3.01199 8.57361C1.67699 7.31361 0.370986 6.82361 0.370986 6.82361C0.370986 6.82361 -0.514014 10.0346 0.447986 12.4426C0.943986 13.6856 2.10899 14.1216 3.12099 14.2526C1.24399 14.5726 -1.42909e-05 15.2606 -1.42909e-05 15.2606C-1.42909e-05 15.2606 1.80199 18.0216 4.19199 18.7876C4.28699 18.8186 4.37999 18.8476 4.47099 18.8756C2.89399 19.8206 1.99999 20.8496 1.99999 20.8496C1.99999 20.8496 3.98399 22.9116 6.92799 22.9276C6.30999 23.9406 6.04499 24.6906 6.04499 24.6906C6.04499 24.6906 9.47099 25.4646 12 24.4376C14.529 25.4646 17.955 24.6906 17.955 24.6906C17.955 24.6906 17.69 23.9406 17.072 22.9276C20.015 22.9116 22 20.8496 22 20.8496C22 20.8496 21.106 19.8206 19.529 18.8756C19.62 18.8476 19.712 18.8186 19.808 18.7876C22.198 18.0216 24 15.2606 24 15.2606V15.2596Z",
    fill: "url(#paint0_linear_807_38149)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_38149",
    x1: 25.4989,
    y1: 0.84961,
    x2: 4.49882,
    y2: 24.8487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6591B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A77950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B6591B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A77950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6591B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_38149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition3);
export default __webpack_public_path__ + "static/media/Position-3.0ca17dbe1a1180a02cacb1a77c9b36a2.svg";
export { ForwardRef as ReactComponent };